import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuth } from '@/hooks/useAuth';

export function useDashboardStats() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['dashboard-stats', user?.hospital_id],
    queryFn: () => {
      if (!user?.hospital_id) {
        throw new Error('No hospital ID available');
      }
      return api.getDashboardMetrics();
    },
    staleTime: 1 * 60 * 1000, // 1 minute
    enabled: !!user?.hospital_id,
  });
}
